import React, { useContext } from 'react';
import { useAppStore } from '../../../GlobalStore/GlobalStore';
import { GlobalContext } from '../../../App';
import microphone from '../../../assets/microphone.svg';
import { startRecording } from '../MediaInput/utils/recordingUtils';
import languageToIdMapping from '../../../Utils/IdMappings/languageToIdMapping';

export const getSpeechPhrases = (settingsObjRef: any) => {
    return {
        "send message": settingsObjRef.current.sendMessagePhrase,
        "stop output": settingsObjRef.current.stopOutputPhrase,
        "stop recording": settingsObjRef.current.stopRecordingPhrase
    };
}

const VoiceMode = () => {
    const { settingsObjRef, websocketRef, setupWebsocketHelper, miscMidRenderRefs, stopRecordingHelper } = useContext(GlobalContext);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { recordingType } = dynamicStateObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleSpeech = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (!settingsObjRef.current) {
            console.warn('Settings not available');
            return;
        }

        if (recordingType) {
            stopRecordingHelper();
            return;
        }

        try {
            const sttOptions = {
                onDataAvailable: async (data: Blob) => {
                    if (websocketRef.current?.readyState === WebSocket.OPEN) {
                        const buffer = await data.arrayBuffer();

                        websocketRef.current?.send(JSON.stringify({
                            functionName: 'speechToText',
                            args: {
                                audioData: Array.from(new Uint8Array(buffer)), isBase64: false, inputType: 'webm',
                                primaryLanguage: languageToIdMapping[settingsObjRef.current.primaryLanguage],
                                secondaryLanguage: settingsObjRef.current.secondaryLanguage? languageToIdMapping[settingsObjRef.current.secondaryLanguage] : null,
                                speechPhrases: getSpeechPhrases(settingsObjRef)
                            }
                        }));
                    }
                },
                onStop: () => {
                    if (websocketRef.current?.readyState === WebSocket.OPEN) {
                        websocketRef.current?.send(JSON.stringify({
                            functionName: 'speechToText',
                            args: { done: true }
                        }));
                    }
                }
            };

            await startRecording('speech', sttOptions, miscMidRenderRefs, environment, vscode, setDynamicStateObj, websocketRef, setupWebsocketHelper);
        } catch (error) {
            console.error('Speech recording error:', error);
            stopRecordingHelper();
        }
    };

    return (
        <button
            onClick={handleSpeech}
            className={`w-8 h-8 flex items-center justify-center rounded-full transition-all duration-200 border
                ${recordingType === 'speech' 
                    ? 'bg-red-500 hover:bg-red-600 shadow-lg border-red-600' 
                    : 'hover:bg-neutral-200  dark:hover:bg-neutral-700 border-neutral-300 dark:border-neutral-600'}`}
            data-tooltip-id="main-tooltip"
            data-tooltip-content={recordingType === 'speech' ? "Stop recording" : "Voice mode"}
            data-tooltip-place="top"
        >
            <img
                src={microphone}
                alt="Voice Mode"
                className={`w-[18px] h-[18px] dark:invert`}
            />
        </button>
    );
};

export default VoiceMode;